import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a8d0782755b8c0014318abc_1788761998136_66972def/richesse/src/app/not-found.tsx");
